import { LinkButton, useDeviceType } from '@cian/ui-kit';
import { useLinkButtonProps } from 'shared/hooks';
import { UTP } from './constants';
import * as styles from './styles.css';
import { LK_MY_OFFERS_LINK } from 'shared/constants/links';
import { clsx } from 'clsx';

export const PayRealResult: React.FC = () => {
  const linkButtonProps = useLinkButtonProps();
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['title']}>Платите только за реальный результат</div>
      <div className={styles['list']}>
        {UTP.map((item, index) => (
          <div className={styles['item']} key={index}>
            <img src={item.image} alt={item.title} className={styles['image']} />
            <div>
              <div className={styles['item-title']}>{item.title}</div>
            </div>
          </div>
        ))}
      </div>
      <div className={styles['btn']}>
        <LinkButton {...linkButtonProps} href={LK_MY_OFFERS_LINK}>
          Подключить
        </LinkButton>
      </div>
    </div>
  );
};
